import React, { Component } from "react";
import styles from "./Needs.module.css";
import {Link } from "react-router-dom";

class Needs extends Component {
  render() {
    return (
      <div className={styles.needs}>
        <div className={styles.heading}>What you need ?</div>
        <div className={styles.needsName}>
          <Link to="/food" className={styles.food}>
            <div className={styles.name}>Food</div>
          </Link>
          <Link to="direction" className={styles.direction}>
            <div className={styles.name}>Direction</div>
          </Link>
          <Link to="medical" className={styles.medical}>
            <div className={styles.name}>Medical Help</div>
          </Link>
          <Link to="technical" className={styles.technical}>
            <div className={styles.name}>Technical Help</div>
          </Link>
        </div>
      </div>
    );
  }
}

export default Needs;
